<template>
    <v-card class="ads-container" outlined flat>
        <div class="top-container">
            <div class="general-info">
                <img :src="imageUrl" alt="">
                <div>
                    <h3>{{clientName ? clientName : 'Dr. John Smith, OD'}}</h3>
                    <p>{{lineWork ? lineWork : 'Line of work'}}</p>
                    <a :href="website">Visit site</a>
                </div>
            </div>
            <div class="business-info">
                <v-icon color="red">place</v-icon>
                <div>
                    <h3>{{businessName ? businessName : 'Your business name'}}</h3>
                    <p>{{address ? address : 'Example Address 1862, 6th Street, Miami, Fl'}}</p>
                    <a :href="`tel:${phone}`">{{phone ? phone : '9999999999' | phoneNumber}}</a>
                </div>
            </div>
        </div>
        <div class="bottom-container">
            <h3 class="custom-message">{{shortDescription ? shortDescription : 'Custom informative message'}}</h3>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'AdComponent',
    props: {
        clientName: String,
        businessName: String,
        lineWork: String,
        website: String,
        address: String,
        phone: String,
        imageUrl: String,
        shortDescription: String
    },
    filters: {
        phoneNumber: function (value) {
            if (!value) return '';
            return `(${value.slice(0, 3)}) ${value.slice(3, 6)} ${value.slice(6)}`;
        }
    }
};
</script>

<style lang="scss" scoped>
    .ads-container {
        display: flex;
        align-self: center;
        justify-content: space-between;
        flex-direction: column;
        height: 150px;
        max-height: 150px;
        width: 100%;
        max-width: 550px;
        padding: 20px;

        .top-container {
            display: flex;
            justify-content: space-between;

            .general-info {
                display: flex;
                max-width: 50%;
                justify-self: flex-start;

                img {
                    margin-right: 10px;
                    width: 50px;
                    min-width: 50px;
                    height: 50px;
                    min-height: 50px;
                }
            }

            .business-info {
                display: flex;
                max-width: 50%;
                justify-self: flex-end;

                i {
                    margin-right: 10px;
                    align-self: flex-start;
                }
            }
        }

        a {
            margin: 0;
        }

        p {
            color: #707070;
            margin: 0;
            word-break: normal;
            white-space: normal;
        }

        .bottom-container {
            border-top: 1px solid #DADCE0;
            margin-top: 10px;

            .custom-message {
                margin: 0;
                color: #707070;
            }
        }
    }
</style>